import useStore from "../modules/useStore";

export default function NavHeader() {
  const { onProjects, showProjects, showIntro } = useStore(
    ({ onProjects, showProjects, showIntro }) => ({
      onProjects,
      showProjects,
      showIntro,
    })
  );
  return (
    <header className="px-4 md:px-10 py-14 h-0 fixed top-0 left-0 text-white text-2xl flex items-center justify-between w-full font-normal z-20">
      <h2
        className="text-base md:text-2xl cursor-pointer opacity-50 hover:opacity-100 transition-all duration-200"
        onClick={onProjects ? showIntro : showProjects}
      >
        {onProjects ? "About" : "Projects"}
      </h2>
      <h2 className="text-base md:text-2xl opacity-50">CPH - DK</h2>
    </header>
  );
}
